import { Directive } from "@angular/core";
import { BaseComponent, UserService } from "@mypxplat/xplat/core";

@Directive()
export abstract class MagicbundleRedeemSuccessBaseComponent extends BaseComponent {
  public text: string = "MagicbundleRedeemSuccess";

  constructor(userService: UserService) {
    super(userService);
  }
}
